const expiredValidator = (isoDateString: string): boolean => {
	const now = new Date()
	const targetDate = new Date(isoDateString)
	return targetDate < now
}

export default expiredValidator
